class Row {
  private _obj:Record<string,string>={};
  private _lineNumber:number;
  private _error:string|undefined;
  private _length: number;

  constructor(lineNumber:number, array:string[], error?:string) {
    this._lineNumber = lineNumber;
    this._error = error;
    this._length = array.length;

    for (let i = 0; i < array.length; i++) {
      const fieldIndex = i.toString();
      this._obj[fieldIndex] = array[i];
    }
    this._obj["lineNumber"] = lineNumber.toString();
  }

  get object() {
    return this._obj;
  }

  get lineNumber() {
    return this._lineNumber;
  }

  get length() {
    return this._length;
  }

  get error() : string {
    if (!this._error) {
      return "";
    }
    return this._error;
  }

  hasError() : boolean {
    return this._error !== undefined && this._error !== "";
  }

  isEmpty() : boolean {
    return Object.keys(this._obj).length === 0 || this._obj[0] === ""
  }

  getData(index:number) : string {
    return this._obj[index];
  }
  
  putData(index:number, data:string) {
    this._obj[index] = data;
  }
}

class DelimitedTextFile {
  private _file: File;
  private _delimiter: string;
  private _quote: string | undefined;
  private _data: Row[] = [];
  private _linesToExclude: number;

  constructor(file: File, delimiter:string, linesToExclude:number=0, quote?:string) {
    this._file = file;
    this._delimiter = delimiter;
    this._quote = quote;
    this._linesToExclude = linesToExclude;
  }

  async readContent() {
    const fileContent = await this._file.text();
    const lineEnding = fileContent.indexOf("\r\n") !== -1 ? "\r\n" : "\n";
    const lines = fileContent.split(lineEnding);
    
    this._data = lines
      .slice(this._linesToExclude)
      .map((line, i) => {
        const result = this.parseLine(line, this._delimiter, this._quote)
        return new Row((i+this._linesToExclude), result[0], result[1]);
      })
  }

  private parseLine(line:string, delimiter:string, quote?:string) : [string[], string] {
    const quoted:boolean = quote ? true : false;

    const characters = line.split("").reverse();

    let last = "";
    let field = "";
    const row:string[] = [];
    let insideQuote = false;
    while (characters.length > 0) {
      const current = characters.pop();
      //let log = "[" + current;
      if (!current) {
        break;
      }
      else if (quoted && current === quote && last !== "\\") {
        last = current;
        //log += !insideQuote ? " (StartQuote) " : " (EndQuote) "
        insideQuote = !insideQuote;
      }
      else if (!insideQuote && current === delimiter && last !== "\\") {
        row.push(field)
        field = "";
        //log += " (Delimiter) "
      }
      else {
        if (current !== "\\") {
            field += current;
            //log += " (literal) "
        }
      }
      //logs += log + "]\n";
      last = current;
    }

    if (!insideQuote || !quoted) {
        row.push(field);
        return [row, ""];
    }
    else {
        return [row, "Cannot parse [" + field + "]"];
    }
  }

  getRows() {
    return this._data;
  }
}

export { DelimitedTextFile, Row}